/** Grymwyrd 简体中文主页文案。 */
export const homeZhCN = {
  'home.heroEyebrow': '一个鲜活的恐怖幻想世界',
  'home.heroTitle': '步入暮光',
  'home.heroBody':
    'Grymwyrd 是一个充满维多利亚哥特恐怖的世界，雾气笼罩的城镇 Greywick 隐藏着残破的塔楼、庄园的地下室，以及最好别提的仪式。塑造你的英雄，揭开大灾变的面纱，在这个世界留下永不磨灭的名字。',
  'home.heroPlayCta': '立即游玩',
  'home.heroBrowseCta': '浏览百科',
  'home.heroQuickstartPrompt': '还没准备好游玩？获取免费的 Quickstart',
}
